type LangFallbackMap = { [key: string]: string }

export const parseSupportedLangs = (raw?: string): LangFallbackMap => {
	const map: LangFallbackMap = {}
	if (!raw) return map

	raw
		.split(',')
		.map(e => e.trim())
		.filter(Boolean)
		.forEach(entry => {
			// case: ca:ca-ES
			if (entry.includes(':')) {
				const [lang, fallback] = entry.split(':')
				if (lang && fallback) {
					map[lang.trim()] = fallback.trim()
				}
			}
			// case: en-US (canonical language)
			else {
				map[entry] = entry
			}
		})
	return map
}
